// extracted by mini-css-extract-plugin
export default {"ArticleWrapper":"ArticleLayout_ArticleWrapper__fddZ9","ArticleContainer":"ArticleLayout_ArticleContainer__IgBbQ"};